import { render } from "./WeddingKioskFormType4.vue?vue&type=template&id=5281d61c&lang=true"
import script from "./WeddingKioskFormType4.vue?vue&type=script&lang=js"
export * from "./WeddingKioskFormType4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__